<div class="row">
    <div class="container-fluid pl-0 pr-0">
        <div class="row">
            <div class="col-xl-12">

                <div class="card card-header-actions ">
                    <div class="card-header">
                        Vaccine Schedule
                        <button class="btn btn-blue btn-icon float-right" (click)="openModal()"
                                *ngIf="!showDetails && (screennames?.screen_name == 'vaccineschedule' ? screennames.can_insert : '')">
                                <i class="fa fa-plus"></i>
                            </button>
                        <a class="float-right"  style="cursor: pointer;" *ngIf="showDetails" (click)="onBack()">Back</a>
                    </div>
                    <div class="card-body">

                        <div class="row mt-4">
                            <div class="col-xl-12" *ngIf="showList">
                                <div class="table-responsive">
                                    <table datatable [dtOptions]="dtOptions" *ngIf="dtRender"
                                        class="table table-striped table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th style="width:5%">S.No</th>
                                                <th>Vaccine Schedule Type</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let item of lstGrid;let i=index">
                                                <td>{{i+1}}</td>
                                                <td>{{item.period_name}}</td>
                                                <td>{{item.is_active==true?'Active':'In Active'}}</td>
                                                <td>
                                                     <span>
                                                <a class="badge badge-info badge-pill pointer" title="Edit"  *ngIf="!showDetails && (screennames?.screen_name == 'vaccineschedule' ? screennames?.can_update : '')"
                                                    (click)="onEdit(item,'e')">
                                                    <i class="fa fa-edit text-white"></i></a>&nbsp;
                                            </span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showDetails">
                            <form [formGroup]="vaccinescheduleForm">
                                <div class="row">
                                    <div class="col-xl-3"></div>
                                    <div class="col-xl-3 mb-2">
                                        <label class="form-label">Vaccination Schedule Period <span
                                                class="text-danger"  >*</span>:</label>
                                    </div>
                                    <div class="col-xl-3 mb-2">
                                        <input type="text" class="form-control form-control-sm"
                                            formControlName="period_name" maxlength="50" size="30"
                                            [ngClass]="{'is-invalid': submitted && fc.period_name.errors}">
                                            <div *ngIf="submitted && fc.period_name.errors" class="invalid-feedback">
                                                <div *ngIf="fc.period_name.errors['required']">Vaccination Schedule Period  is required
                                                </div>
                                            </div>
                                    </div>

                                </div>
                                <div class="row mt-2">

                                    <div class="col-xl-3"></div>
                                    <div class="col-xl-3">
                                        <label class="control-label"> Status : </label>
                                    </div>
                                    <div class="col-xl-3">
                                        <input type="radio" formControlName="is_active" [value]=true>Active
                                        <input type="radio" formControlName="is_active" [value]=false>In Active
                                    </div>
                                </div>
                            </form>

                            <div class="text-center mt-4">

                                <button type="button" class="btn btn-sm btn-primary" (click)="onSave()"><i
                                        class="fa fa-save"></i> {{!isEdit ? ' Save' : ' Update'}}</button>&nbsp;&nbsp;
                                <button type="button" class="btn btn-sm btn-danger" (click)="onBack()">
                                    <i class="fa fa-close"></i> Cancel</button>


                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>